<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100"
          >
            <h1 class="title">Guest Rooms
              <br>
              <small class="text-white">Let's Reserve Online</small>
            </h1>
            <!-- <h4>
              Welcome!
            </h4> -->
            <br />
            <md-button
              href="/chooseGuestDate"
              class="md-orange md-lg"
              target="_self"
              ><md-icon>today</md-icon>Reservation</md-button
            >
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-60 md-xsmall-size-100 mx-auto text-center"
            >
              <!-- <h5 class="title text-left"></h5> -->
              <h5 class="md-body-3 text-left">
                Furnished Studio $995/Month - Best rate in Sherman! <br>Take advantage of our special discounted rate! All utilities are included! No credit, no lease needed!<br>
                Looking for a place to call home for a couple months or longer? We have everything you need without the hassles of traditional apartments, all at a great rate. Each room comes with plenty of workspace. And unlike apartments, cable and Wi-Fi are already hooked up and free! With no leases and no credit checks, we are move-in ready. So just bring yourself - and your furry family member - and feel right at home.<br>
                <h4 class="title">Property Amenities</h4>
                24-Hour Reception Desk, Banquet Facilities, Business Center, Coffee/Tea Maker, Cribs Available, Housekeeping, Flat Screen Televisions, Free Cable with Premium Channels, Free Wi-Fi. Hairdryer, Free Local Calls & Voicemail, Laundry Facilities, Meeting Room, Multilingual Staff, Non-Smoking, Onsite Parking, Pool - Outdoor<br>
                Call or text 903 718 0189 to Reserve Now!
              </h5>
            </div>
            <div
              class="md-layout-item md-size-40 md-xsmall-size-100 mx-auto"
            >
              <img :src="ourView" class="t_img1" alt="Our Room">
            </div>
          </div>
          <hr>
          <div class="md-layout">
             <div
              class="md-layout-item md-size-40 md-xsmall-size-100 mx-auto"
            >
              <img :src="ourRoom" class="t_img1" alt="Our Room">
            </div>
            <div
              class="md-layout-item md-size-60 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-right">Our Rooms</h2>
              <h5 class="md-body-3 text-right">
                The guest rooms were designed to feel like home with a unique floor plan and cleanliness in mind so that each guest can feel like the first to enjoy the space. Each room is equipped with the essential mini-fridge, hairdryer, and working desk. But, the hallmark of a relaxing stay is a great night of sleep. Our branded mattress promises the comfort and rest. 

                See our various offerings here at the hotel. We have Standard King Rooms, Standard two Double Rooms, also with ADA Accessibility, 1 King Bedroom Suite, 2 Double Bedroom Suite and Deluxe King Bedroom Jacuzzi Suite. Check in is at 3pm and checkout is at 11am. 
              </h5>
            </div>
          </div>
        </div> 
      </div>
      <div class="section">
        <div class="container">
          <div class="features text-center">
            <div class="container">
              <h2 class="title text-center">Our Features</h2>
              <div class="md-layout">
                <div class="md-medium-size-33 md-large-size-33 md-small-size-100">
                  <div class="info">
                    <div class="icon icon-info">
                      <md-icon>pool</md-icon>
                    </div>
                    <h4 class="info-title">Swimming Pool</h4>
                    <div class="md-body-2 t_gImg">
                      <img :src="guest" alt="Swimming Pool" class="img-raised " />
                    </div>
                  </div>
                </div>
                <div class="md-medium-size-33 md-large-size-33 md-small-size-100">
                  <div class="info">
                    <div class="icon icon-success">
                      <md-icon>desktop_windows</md-icon>
                    </div>
                    <h4 class="info-title">Business Center</h4>
                    <div class="md-body-2 t_gImg">
                      <img :src="business" alt="Business Center" class="img-raised " />
                    </div>
                  </div>
                </div>
                <div class="md-medium-size-33 md-large-size-33 md-small-size-100">
                  <div class="info">
                    <div class="icon icon-default">
                      <md-icon>fitness_center</md-icon>
                    </div>
                    <h4 class="info-title">Fitness center</h4>
                    <div class="md-body-2 t_gImg">
                      <img :src="fitness" alt="Fitness center" class="img-raised " />
                    </div>
                  </div>
                </div>
                <div class="md-medium-size-33 md-large-size-33 md-small-size-100">
                  <div class="info">
                    <div class="icon icon-warning">
                      <md-icon>local_bar</md-icon>
                    </div>
                    <h4 class="info-title">Bar</h4>
                    <div class="md-body-2 t_gImg">
                      <img :src="bar" alt="Bar" class="img-raised " />
                    </div>
                  </div>
                </div>
                <div class="md-medium-size-33 md-large-size-33 md-small-size-100">
                  <div class="info">
                    <div class="icon icon-danger">
                      <md-icon>restaurant_menu</md-icon>
                    </div>
                    <h4 class="info-title">Restaurant</h4>
                    <div class="md-body-2 t_gImg">
                      <img :src="restaurant" alt="Restaurant" class="img-raised " />
                    </div>
                  </div>
                </div>
                <div class="md-medium-size-33 md-large-size-33 md-small-size-100">
                  <div class="info">
                    <div class="icon icon-rose">
                      <md-icon>local_laundry_service</md-icon>
                    </div>
                    <h4 class="info-title">Laundry</h4>
                    <div class="md-body-2 t_gImg">
                      <img :src="laundry" alt="Laundry" class="img-raised " />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-imgs">
        <div class="container">
          <div class="elevation-demo">
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[1] = true">
                <img
                  :src="img1"
                  alt="King Bed"
                  class="img-raised"
                />
                <i>King Bed</i>
              </a>
              <modal v-if="classicModal[1]" @close="classicModalHide(1)">
                <template slot="header">
                  <h4 class="modal-title">King Bed</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(1)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img1"
                  alt="King Bed"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(1)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[2] = true">
                <img
                  :src="img2"
                  alt="2 Double Beds"
                  class="img-raised"
                />
                <i>2 Double Beds</i>
              </a>
              <modal v-if="classicModal[2]" @close="classicModalHide(2)">
                <template slot="header">
                  <h4 class="modal-title">2 Double Beds</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(2)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img2"
                  alt="2 Double Beds"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(2)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[3] = true">
                <img
                  :src="img3"
                  alt="Deluxe Suite"
                  class="img-raised"
                />
                <i>Deluxe Suite</i>
              </a>
              <modal v-if="classicModal[3]" @close="classicModalHide(3)">
                <template slot="header">
                  <h4 class="modal-title">Deluxe Suite</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(3)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img3"
                  alt="Deluxe Suite"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(3)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[4] = true">
                <img
                  :src="img4"
                  alt="Suite King Bed"
                  class="img-raised"
                />
                <i>Suite King Bed</i>
              </a>
              <modal v-if="classicModal[4]" @close="classicModalHide(4)">
                <template slot="header">
                  <h4 class="modal-title">Suite King Bed</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(4)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img4"
                  alt="Suite King Bed"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(4)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[5] = true">
                <img
                  :src="img5"
                  alt="Suite Double Beds"
                  class="img-raised"
                />
                <i>Suite Double Beds</i>
              </a>
              <modal v-if="classicModal[5]" @close="classicModalHide(5)">
                <template slot="header">
                  <h4 class="modal-title">Suite Double Beds</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(5)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img5"
                  alt="Suite Double Beds"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(5)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[6] = true">
                <img
                  :src="img6"
                  alt="Bath"
                  class="img-raised"
                />
                <i>Bath</i>
              </a>
              <modal v-if="classicModal[6]" @close="classicModalHide(6)">
                <template slot="header">
                  <h4 class="modal-title">Bath</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(6)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img6"
                  alt="Bath"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(6)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>

            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[7] = true">
                <img
                  :src="img7"
                  alt="Suite Bath"
                  class="img-raised"
                />
                <i>Suite Bath</i>
              </a>
              <modal v-if="classicModal[7]" @close="classicModalHide(7)">
                <template slot="header">
                  <h4 class="modal-title">Suite Bath</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(7)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img7"
                  alt="Suite Bath"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(7)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[8] = true">
                <img
                  :src="img8"
                  alt="Suite"
                  class="img-raised"
                />
                <i>Suite</i>
              </a>
              <modal v-if="classicModal[8]" @close="classicModalHide(8)">
                <template slot="header">
                  <h4 class="modal-title">Suite</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(8)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img8"
                  alt="Suite"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(8)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
            <md-content class="md-elevation">
              <a href="javascript:void(0)" @click="classicModal[9] = true">
                <img
                  :src="img9"
                  alt="Deluxe Suite"
                  class="img-raised"
                />
                <i>Deluxe Suite</i>
              </a>
              <modal v-if="classicModal[9]" @close="classicModalHide(9)">
                <template slot="header">
                  <h4 class="modal-title">Deluxe Suite</h4>
                  <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="classicModalHide(9)"
                  >
                    <md-icon>clear</md-icon>
                  </md-button>
                </template>

                <template slot="body">
                  <img
                  :src="img9"
                  alt="Deluxe Suite"
                  class="img-raised"
                />
                </template>

                <template slot="footer">
                  <md-button
                    class="md-danger md-simple"
                    @click="classicModalHide(9)"
                    >Close</md-button
                  >
                </template>
              </modal>
            </md-content>
          </div>
        </div>
      </div>
      <hr>
      <div class="section section-bottom">
        <div class="container">
          <div class="md-layout-item md-size-100 text-center">
            <h3 class="title">Book Your Room Now!</h3>
            <h5 class="text-left">Days Inn by Wyndham Sherman features a fitness center and a seasonal outdoor pool. A computer station is located on site and wireless Internet access is complimentary. A business center is on site. Guests can enjoy a complimentary breakfast each morning. Event facilities measuring 3300 square feet (307 square meters) include conference space. This business-friendly hotel also offers a terrace, barbecue grills, and a vending machine. Complimentary self parking is available on site. Days Inn Sherman TX is a garden look, INTERIOR corridor hotel conveniently located off Highway 75 at exit 56. We have bar and restaurant in the hotel, and we have a movie theater, bowling, amusement arcade right next door!</h5>
            <md-button
              href="/chooseGuestDate"
              class="md-orange md-lg"
              target="_self"
              ><md-icon>today</md-icon>Reserve Room Now
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
export default {
  components: {
    Modal
  },
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/guest_header.jpg")
    },
    ourRoom: {
      type: String,
      default: require("@/assets/img/NDD1.jpg")
    },
    ourView: {
      type: String,
      default: require("@/assets/img/Extra_Court_Yard1.jpg")
    },
    img1: {
      type: String,
      default: require("@/assets/img/NK1.jpg")
    },
    img2: {
      type: String,
      default: require("@/assets/img/NDD1.jpg")
    },
    img3: {
      type: String,
      default: require("@/assets/img/guest_bath.jpg")
    },
    img4: {
      type: String,
      default: require("@/assets/img/SNK1_1.jpg")
    },
    img5: {
      type: String,
      default: require("@/assets/img/SuiteDoubleFull3_SND2.jpg")
    },
    img6: {
      type: String,
      default: require("@/assets/img/StdBath.jpg")
    },
    img7: {
      type: String,
      default: require("@/assets/img/StandardVanity2.jpg")
    },
    img8: {
      type: String,
      default: require("@/assets/img/SND2.jpg")
    },
    img9: {
      type: String,
      default: require("@/assets/img/guest_suite.jpg")
    },
    guest: {
      type: String,
      default: require("@/assets/img/guest_pool.jpg")
    },
    business: {
      type: String,
      default: require("@/assets/img/guest_business.jpg")
    },
    fitness: {
      type: String,
      default: require("@/assets/img/guest_fitness.jpg")
    },
    bar: {
      type: String,
      default: require("@/assets/img/guest_bar.jpg")
    },
    restaurant: {
      type: String,
      default: require("@/assets/img/guest_restaurant.jpg")
    },
    laundry: {
      type: String,
      default: require("@/assets/img/guest_laundry.jpg")
    }
  },
  data() {
    return {
      classicModal: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false
      },
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    classicModalHide(e) {
      this.classicModal[e] = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 40px;
}
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.page-header {
  b {
    font-size: 4.2rem
  }
}
.info{
  padding-top: 20px;
}
.t_gImg{
  padding: 0 60px;
}
.elevation-demo {
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
}
.t_img1 {
  margin-top: 58px;
}
hr {
  margin-top: 1rem;
  border: 0;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.md-elevation {
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    width: 100%;
    height: 100%;
    position: relative;
    i {
      display: table-cell;
      position: absolute;
      top:0;
      right: 0;
      bottom: 0;
      left: 0;
      font-size: 2.0rem;
      font-weight: bold;
      vertical-align: middle;
      text-align: center;
      font-style: normal; 
      background: rgba(245, 124, 0, 0.5);
      color: #fff;
      opacity: 0;
      z-index: 9;
      padding: 50% 0 0 0;
      transition: opacity 0.4s ease 0s;
    }
    &:hover {
      i {
        opacity: 1;
      }
    }
  }
}
.md-elevation {
 width: 33.3333%;
}
@media (max-width: 768px){
  .md-elevation {
    width: 100%;
  }
}
</style>
